module.exports = __webpack_public_path__ + "img/l-cb-n1.aaf76495.gif";